import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_API_KEY;
const POSTHOG_HOST = 'https://us.i.posthog.com';

let initialized = false;

/**
 * Initialize PostHog analytics
 */
export function initAnalytics(): void {
  if (initialized || !POSTHOG_KEY) {
    if (!POSTHOG_KEY) {
      console.log('[Analytics] PostHog API key not configured, analytics disabled');
    }
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false, // We handle this manually for SPA routing
    capture_pageleave: true,
    autocapture: false, // Manual tracking for better control
    persistence: 'localStorage',
  });

  initialized = true;
  console.log('[Analytics] PostHog initialized');
}

/**
 * Track a page view
 */
export function trackPageView(path: string): void {
  if (!initialized) return;
  posthog.capture('$pageview', { $current_url: window.location.origin + path });
}

/**
 * Track feature usage
 */
export function trackFeatureUsed(feature: string, properties?: Record<string, any>): void {
  if (!initialized) return;
  posthog.capture('feature_used', { feature, ...properties });
}

/**
 * Track a custom event
 */
export function trackEvent(eventName: string, properties?: Record<string, any>): void {
  if (!initialized) return;
  posthog.capture(eventName, properties);
}

/**
 * Identify a user for analytics
 */
export function identifyUser(userId: string, traits?: Record<string, any>): void {
  if (!initialized) return;
  posthog.identify(userId, traits);
}

/**
 * Reset user identity (call on logout)
 */
export function resetUser(): void {
  if (!initialized) return;
  posthog.reset();
}
